import keyMirror from 'keymirror'
import i18n from '@/utils/i18n'

export const CONTRACTOR_TYPES = keyMirror({
  MAIN: null,
  AC: null,
  ELECTRICAL: null,
  FIRE_SERVICE: null,
  PLUMBING: null,
  SECURITY: null,
  OTHER: null,
})

export function getContractorTypes () {
  return {
    MAIN: i18n.t('workPermit.contractorType.main'),
    AC: i18n.t('workPermit.contractorType.ac'),
    ELECTRICAL: i18n.t('workPermit.contractorType.electrical'),
    FIRE_SERVICE: i18n.t('workPermit.contractorType.fireService'),
    PLUMBING: i18n.t('workPermit.contractorType.plumbing'),
    SECURITY: i18n.t('workPermit.contractorType.security'),
    OTHER: i18n.t('workPermit.contractorType.other'),
  }
}

export function getContractorTypeOptions () {
  return [
    { code: 'MAIN', label: i18n.t('workPermit.contractorType.main') },
    { code: 'AC', label: i18n.t('workPermit.contractorType.ac') },
    { code: 'ELECTRICAL', label: i18n.t('workPermit.contractorType.electrical') },
    { code: 'FIRE_SERVICE', label: i18n.t('workPermit.contractorType.fireService') },
    { code: 'PLUMBING', label: i18n.t('workPermit.contractorType.plumbing') },
    { code: 'SECURITY', label: i18n.t('workPermit.contractorType.security') },
    { code: 'OTHER', label: i18n.t('workPermit.contractorType.other') },
  ]
}
export const ContactExample = {
  firstName: '',
  lastName: '',
  phone: '',
  altPhone: '',
}

export const ContractorExample = {
  company: { name: '', type: '' },
  primaryContact: { ...ContactExample },
}

export const RepAccessTypes = keyMirror({
  CONTRACTOR: null,
  NORMAL: null,
})
